// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"11":"1e76d53a","787":"785de90c"}[chunkId] + ".chunk.js";
};